import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from "../../global";
import axios from "axios";
import { toast } from "react-toastify";


const AddionalAgentAssistantcomponent = ({ isaddionalagentassistantModalOpen, closeaddionalagentassistantModal, selectedFile, handleContinueClick, fetchAllCases }) => {



    const [ogagentassistantlist, setogagentassistantlist] = useState([]);
    const [agentassistantlist, setagentassistantlist] = useState([]);
    const [selecteditem, setSelecteditem] = useState(null);
    const [loading, setLoading] = useState(true);
    const handleClose = () => {
        closeaddionalagentassistantModal();
    };
    const handleSubmit = async () => {
        try {

            const selectedAgents = agentassistantlist.filter(a => a.agentIsSelected === 1);
            const originalAgents = ogagentassistantlist.filter(a => a.agentIsSelected === 1);
            const newAgents = selectedAgents.filter(
                sa => !originalAgents.some(og => og.agentAssistantId === sa.agentAssistantId)
            );

            const payload = {
                case_id: selectedFile?.caseId,
                service_id: selectedFile?.caseServiceId,
                // selectedAgents: selectedAgents.map(a => a.agentAssistantId),
                // originalAgents: originalAgents.map(a => a.agentAssistantId),
                // newAgents: newAgents.map(a => a.agentAssistantId),
                assistant_agents:  selectedAgents.map(a => a.agentAssistantId),
                mode: "AddAgents",
            };


            const response = await axios.post(`${API_BASE_URL}services`, payload);

            if (response.data.status === 1) {
                toast.success("Agents assistant submitted successfully!");
                closeaddionalagentassistantModal();
                fetchAllCases();
            } else {
                toast.error(response.data?.message);
            }
        } catch (err) {
            console.error("Error submitting agents:", err);
             toast.error("Error submitting agents:", err);
        }
    };


    const fetchDetails = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}services`, {
                case_id: selectedFile?.caseId,
                service_id: selectedFile?.caseServiceId,
                mode: "AgentAssistant",
            });


            if (response.data.status === 1) {
                const agentassistantlist = response.data.message;
                setagentassistantlist(agentassistantlist);
                setogagentassistantlist(agentassistantlist);
            } else {
                setagentassistantlist([]);
                setogagentassistantlist([]);
            }
        } catch (err) {
            console.error("Error fetching item details:", err);
            setagentassistantlist([]);
            setogagentassistantlist([]);
        } finally {
            setLoading(false);
        }
    };

    // Toggle agent selection
    const handleAgentToggle = (agentId) => {
        setagentassistantlist((prev) =>
            prev.map((agent) =>
                agent.agentAssistantId === agentId
                    ? { ...agent, agentIsSelected: agent.agentIsSelected === 1 ? 0 : 1 }
                    : agent
            )
        );
    };
    useEffect(() => {
        if (selectedFile) {
            setSelecteditem(selectedFile);
            fetchDetails();
        }
    }, [selectedFile, isaddionalagentassistantModalOpen]);

    return (
        <>
            {isaddionalagentassistantModalOpen && (
                <div className="modal spl-modal fade show supplement-page" style={{ display: 'block', zIndex: 999 }} tabIndex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            {/* Header */}
                            <div className="modal-header">
                                <h5 className="modal-title" id="uploadModalLabel">Select Additional Summary Agent Assistant</h5>
                                <button type="button" className="btn-close" onClick={handleClose} style={{ fontSize: 'large' }}>
                                    <svg width={18} height={18} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                                        <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z" />
                                    </svg>
                                </button>
                            </div>

                            {/* Body */}
                            <div className="modal-body d-block" >
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="d-flex justify-content-start gap-1">
                                        <div className="job-selection w-100">
                                            <div className="mb-0 w-100">
                                                <div className='additional-agents-inner'
                                                    style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(auto-fit, minmax(175px, 175px))',
                                                        rowGap: '20px',
                                                        width: '100%',
                                                        justifyContent: "start",
                                                    }}
                                                >
                                                    {agentassistantlist?.map((item) => {
                                                        const isSelected = item.agentIsSelected === 1;
                                                        const isOriginal = ogagentassistantlist.some(
                                                            (og) => og.agentAssistantId === item.agentAssistantId && og.agentIsSelected === 1
                                                        );


                                                        return (
                                                            <a
                                                                className={`avatar-items ${isSelected ? 'active position-relative' : 'position-relative'}`}
                                                                key={`assistant${item.agentAssistantId}`}
                                                                style={{
                                                                    width: '90%',
                                                                    padding: '5px',
                                                                    cursor: 'pointer',
                                                                    position: 'relative',
                                                                    margin: '5px',
                                                                    borderRadius: "8px",
                                                                    backgroundColor: isSelected ? "#f0f8ff" : "#fff",
                                                                    opacity: isOriginal ? 0.4 : 1,
                                                                    pointerEvents: isOriginal ? 'none' : 'auto',
                                                                    cursor: isOriginal ? "not-allowed" : "pointer",
                                                                }}
                                                                onClick={() => !isOriginal && handleAgentToggle(item.agentAssistantId)}
                                                            >
                                                                {/* Tick */}
                                                                {isSelected && (
                                                                    <span
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '5px',
                                                                            right: '5px',
                                                                            background: '#000',
                                                                            color: '#fff',
                                                                            borderRadius: '50%',
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            fontSize: '12px'
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-check"></i>
                                                                    </span>
                                                                )}

                                                                {/* Content */}
                                                                <div
                                                                    className="text-center"
                                                                    style={{ display: 'flex', alignItems: 'center', alignContent: 'center', gap:'8px' }}
                                                                >
                                                                    <img
                                                                        src={item.assistantImg}
                                                                        alt=""
                                                                        style={{ width: '50px' }}
                                                                    />
                                                                    <div className="d-flex flex-column text-left align-items-start agents-info text-black">
                                                                        <h5 className="mb-1">{item.assistantName}</h5>
                                                                        <p className="my-0 text-start"> {item.assistantLabel}</p>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {agentassistantlist.some(a => {
                                    const isNowSelected = a.agentIsSelected === 1;
                                    const wasOriginallySelected = ogagentassistantlist.some(
                                        og => og.agentAssistantId === a.agentAssistantId && og.agentIsSelected === 1
                                    );
                                    return isNowSelected && !wasOriginallySelected; // new agent
                                }) && (
                                        <div className="d-flex justify-content-end mt-3 ">
                                            <button
                                                className="btn common-btn d-flex justify-content-center align-items-center h-100 custom-file-button"
                                                onClick={handleSubmit}
                                            >
                                                <h4 className="mb-0 me-0 fs-5 fw-normal">
                                                    Submit<i className="fa-solid fa-arrow-right ms-1"></i>
                                                </h4>
                                            </button>
                                        </div>
                                    )}
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddionalAgentAssistantcomponent;
